import { connect } from 'react-redux';
import SwitcherList from './SwitcherList';
import { getAllBypassedSubscriptions } from 'reducers';
import { fetchAll as fetchSubs } from 'subscriptions/bypassed/actions';

const mapStateToProps = (state) => ({
  subs: getAllBypassedSubscriptions(state)
});

const mapDispatchToProps = {
  fetchSubs
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SwitcherList);

